const fn = {
  init: () => {
    fn.fixFtColoredBullets()
    fn.setupFitVids()
  },

  fixFtColoredBullets: () => {
    document.querySelectorAll('.page-content-wrapper li a[href$=".pdf"]:first-child').forEach(el => {
      const $parent = el.closest('li')
      $parent.classList.add('has-ft')
    })
  },

  setupFitVids: () => {
    $('.ss-htmleditorfield-file.embed').fitVids();
    $('.ss-htmleditorfield-file.embed').find('iframe').attr('title', 'Video Embed');
    $('.custom-embed').fitVids({
      customSelector: "iframe[src^='https://vcloud.volarvideo.com']"
    });
  }
}

export default {
  can: () => true,
  run: fn.init
}
